import React, { lazy, useState } from 'react'
import PropTypes from 'prop-types'
// Centralized lodash imports - much cleaner!
import { map } from '@/utils/lodash'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Grid,
  Box,
  Button,
  Menu,
  Tooltip,
  Typography,
} from '@mui/material'

import AddIcon from '@mui/icons-material/Add'
import { LaunchpadButton } from '@/housefolios-components/shared'

import { headerDotsPaperSx, headerDotsPreviewSx } from '@/layout-blueprints/chromeComponentSx'

const CreatePortfolio = lazy(
  () => import('@/housefolios-components/Portfolio/CreatePortfolio'),
)
const AddPropertyButton = lazy(
  () =>
    import('@/housefolios-components/TitleButtons/AddPropertyButton'),
)
const CreateNewOrg = lazy(
  () =>
    import('@/housefolios-components/OrganizationSettings/CreateNewOrg'),
)
const UploadProperties = lazy(
  () =>
    import('@/housefolios-components/Properties/UploadProperties'),
)

// const inputFields = [
//   {
//     icon1: 'far',
//     icon2: 'play-circle',
//     title: 'Add Property',
//     subTitle: 'Specific address',
//     onClick: (handleOpenCreateNewPortfolio)
//   },
//   {
//     icon1: 'far',
//     icon2: 'question-circle',
//     title: 'Upload Properties',
//     subTitle: 'Multiple addresses'
//   },
//   {
//     icon1: 'fas',
//     icon2: 'magnifying-glass',
//     title: 'Property Searcy',
//     subTitle: 'Search active listings'
//   },
//   {
//     icon1: 'fas',
//     icon2: 'sign-hanging',
//     title: 'Marketplace',
//     subTitle: 'Pre-analyzed deals'
//   },
//   {
//     icon1: 'far',
//     icon2: 'folder',
//     title: 'Create Portfolio',
//     subTitle: 'Keep it organized'
//   },
//   {
//     icon1: 'far',
//     icon2: 'building',
//     title: 'Organization',
//     subTitle: 'Starting new project?'
//   },
// ]

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 3,
          }}
        >
          {children}
        </Box>
      )}
    </Typography>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
}

const HeaderDots = (props) => {
  const [anchorEl3, setAnchorEl3] = useState(null)

  const handleClick3 = (event) => {
    setAnchorEl3(event.currentTarget)
  }
  const handleClose3 = () => {
    setAnchorEl3(null)
  }

  // const [completed, setCompleted] = useState(0);

  // React.useEffect(() => {
  //   function progress() {
  //     setCompleted((oldCompleted) => {
  //       if (oldCompleted === 100) {
  //         return 0;
  //       }
  //       const diff = Math.random() * 10;
  //       return Math.min(oldCompleted + diff, 100);
  //     });
  //   }

  //   const timer = setInterval(progress, 500);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  const inputFields =
    props?.session?.me?.activeOrg?.member === 'RWN'
      ? [
          {
            icon1: 'far',
            icon2: 'map-marker-plus',
            title: 'Single Address',
            subTitle: 'Listed or off-market',
            //onClick: handleOpenCreateNewPortfolio
            component: (
              <AddPropertyButton
                key="add"
                headerDot={true}
                closeParent={handleClose3}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
          {
            icon1: 'far',
            icon2: 'file-excel',
            title: 'Multiple Addresses',
            subTitle: 'Upload Spreadsheet',
            component: (
              <UploadProperties
                key="upload"
                menu
                closeParent={handleClose3}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
          {
            icon1: 'fas',
            icon2: 'sign-hanging',
            title: 'Marketplace',
            subTitle: 'Pre-analyzed deals',
            href: '/marketplace',
            xs: 12,
          },
          {
            icon1: 'fas',
            icon2: 'fa-folder-plus',
            title: 'Create Portfolio',
            subTitle: 'Keep it organized',
            component: (
              <CreatePortfolio
                key="newportfolio"
                headerDot={true}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
          {
            icon1: 'far',
            icon2: 'building',
            title: 'Organization',
            subTitle: 'Starting new project?',
            component: (
              <CreateNewOrg
                key="neworg"
                headerDot={true}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
        ]
      : [
          {
            icon1: 'far',
            icon2: 'map-marker-plus',
            title: 'Single Address',
            subTitle: 'Listed or off-market',
            //onClick: handleOpenCreateNewPortfolio
            component: (
              <AddPropertyButton
                key="add"
                headerDot={true}
                closeParent={handleClose3}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
          {
            icon1: 'far',
            icon2: 'file-excel',
            title: 'Multiple Addresses',
            subTitle: 'Upload Spreadsheet',
            component: (
              <UploadProperties
                key="upload"
                menu
                closeParent={handleClose3}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
          {
            icon1: 'fas',
            icon2: 'magnifying-glass',
            title: 'Property Search',
            subTitle: 'Search active listings',
            href: '/property-search',
          },
          {
            icon1: 'fas',
            icon2: 'sign-hanging',
            title: 'Marketplace',
            subTitle: 'Pre-analyzed deals',
            href: '/marketplace',
          },
          {
            icon1: 'fas',
            icon2: 'fa-folder-plus',
            title: 'Create Portfolio',
            subTitle: 'Keep it organized',
            component: (
              <CreatePortfolio
                key="newportfolio"
                headerDot={true}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
          {
            icon1: 'far',
            icon2: 'building',
            title: 'Organization',
            subTitle: 'Starting new project?',
            component: (
              <CreateNewOrg
                key="neworg"
                headerDot={true}
                disabled={!Boolean(anchorEl3)}
              />
            ),
          },
        ]

  const visibleInputFields =
    String(props?.session?.me?.activeOrg?.member || '').toLowerCase() ===
    'pep'
      ? inputFields.filter((field) => field.title !== 'Property Search')
      : inputFields

  return (
    <>
      <Box
        sx={[{ display: 'flex', alignItems: 'center' }, { display: "flex", alignItems: "center" }]}
        >
        {/* <span>
          <Badge
            variant="dot"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
            badgeContent=" "
            classes={{ badge: 'bg-success badge-circle' }}>
            <Button
              onClick={handleClick1}>
              <span>
                <NotificationsActiveTwoToneIcon />
              </span>
            </Button>
          </Badge>

          <Popover
            open={open1}
            anchorEl={anchorEl1}
            onClose={handleClose1}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            slotProps={{
              paper: { sx: headerDotsPaperSx },
            }}>
            <div>
              <div>
                <div />
                <div>
                  <h4>
                    Notifications
                  </h4>
                  <p>
                    You have <b>472</b> new messages
                  </p>
                </div>
              </div>
              <div>
                <Tabs
                  value={value}
                  variant="fullWidth"
                  onChange={handleChange}>
                  <Tab label="Timeline" />
                  <Tab label="Tasks" />
                  <Tab label="Reports" />
                </Tabs>
              </div>
              <Box sx={headerDotsPreviewSx}>
                <Box sx={{
                  position: "relative",
                  height: "100%",
                  maxHeight: "100%",
                  overflowX: "hidden",
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                }}>
                  <TabPanel value={value} index={0}>
                    <div>
                      <div>
                        <div>9:25</div>
                        <div>
                          <div />
                          <h4>
                            1991
                          </h4>
                          <p>
                            The World Wide Web goes live with its first web
                            page.
                          </p>
                        </div>
                      </div>
                      <div>
                        <div>9:25</div>
                        <div>
                          <div />
                          <h4>
                            Java exam day
                          </h4>
                          <p>
                            Bill Clinton's presidential scandal makes it online.
                          </p>
                          <div>
                            <div>
                              <div>
                                <img alt="..." src={avatar1} />
                              </div>
                            </div>
                            <div>
                              <div>
                                <img alt="..." src={avatar2} />
                              </div>
                            </div>
                            <div>
                              <div>
                                <img alt="..." src={avatar6} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>9:25</div>
                        <div>
                          <div />
                          <h4>
                            Business investor meeting
                          </h4>
                          <p>
                            Mosaic, the first graphical browser, is introduced
                            to the average consumer.
                          </p>
                          <div>
                            <a href="#/" onClick={(e) => e.preventDefault()}>
                              <img
                                alt="..."
                                src={people1}
                                width="70"
                              />
                            </a>
                            <a href="#/" onClick={(e) => e.preventDefault()}>
                              <img
                                alt="..."
                                src={people3}
                                width="70"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>9:25</div>
                        <div>
                          <div />
                          <h4>
                            Learning round table gathering
                          </h4>
                          <p>First ever iPod launches.</p>
                          <div>
                            <Button
                              size="small"
                              variant="contained">
                              Submit Report
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div>9:25</div>
                        <div>
                          <div />
                          <h4>
                            2003
                          </h4>
                          <p>
                            MySpace becomes the most popular social network.
                          </p>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <div>
                      <div>
                        <div>
                          <FontAwesomeIcon
                            icon={['fas', 'xmark']}
                          />
                        </div>
                      </div>
                      <h6>
                        Incoming messages
                      </h6>
                      <p>
                        You have pending actions to take care of.
                      </p>
                    </div>
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <div>
                      Total Sales
                      <small>
                        Total performance for selected period
                      </small>
                    </div>
                    <div>
                      <Chart
                        options={chartHeaderDotsOptions}
                        series={chartHeaderDotsData}
                        type="bar"
                        height={148}
                      />
                    </div>
                  </TabPanel>
                </Box>
              </Box>
              <Divider />
              <div>
                <Badge
                  color="error"
                  variant="dot"
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                  }}>
                  <Button
                    variant="contained">
                    <span>Learn more</span>
                    <span>
                      <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                    </span>
                  </Button>
                </Badge>
              </div>
            </div>
          </Popover>
        </span> */}
        {/* <span>
          <Badge
            variant="dot"
            overlap="circular"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            badgeContent=" "
            classes={{ badge: 'bg-danger badge-circle-sm' }}>
            <Button
              onClick={handleClick2}>
              <span>
                <PollTwoToneIcon />
              </span>
            </Button>
          </Badge>
          <Popover
            open={open2}
            anchorEl={anchorEl2}
            onClose={handleClose2}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}>
            <List
              component="div">
              <ListItem>
                <div>
                  <Badge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right'
                    }}
                    variant="dot">
                    <Avatar alt="Travis Howard" src={avatar7} />
                  </Badge>
                  <div>
                    <span>
                      Emma Taylor
                    </span>
                    <small>
                      This is an accountant profile
                    </small>
                  </div>
                </div>
              </ListItem>
              <ListItem>
                <div>
                  <div>
                    <small>
                      Profile completion
                    </small>
                  </div>
                </div>
                <LinearProgress
                  variant="determinate"
                  value={85}
                />
                <div>
                  <small>0</small>
                  <small>100%</small>
                </div>
              </ListItem>
              <ListItem>
                <Button
                  variant="contained"
                  size="small">
                  <span>
                    <FontAwesomeIcon icon={['fas', 'right-from-bracket']} />
                  </span>
                  <span>Logout</span>
                </Button>
              </ListItem>
            </List>
          </Popover>
        </span> */}
        <Box component="span" sx={{ px: 1 }}>
          <Tooltip title="Common Actions">
            <Button
              variant="contained"
              disableElevation
              onClick={handleClick3}
              sx={{
                "&:hover": { transform: "translateY(0px)", backgroundColor: "#28b854", boxShadow: "none" },
                p: 0,
                width: 44,
                height: 44,
                minWidth: 44,
                minHeight: 44,
                lineHeight: 1,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#28b854",
                boxShadow: "none",
                border: 0,
                overflow: "hidden",
                borderRadius: "0.65rem",
                "& .MuiSvgIcon-root": { display: "block", fontSize: 22 },
              }}
              >
              <AddIcon sx={{ color: 'white' }} />
            </Button>
          </Tooltip>
          <Menu
            anchorEl={anchorEl3}
            keepMounted
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl3)}
            slotProps={{ list: { sx: { p: 0 } } }}
            onClose={handleClose3}
          >
            <Box
              sx={[{ overflow: 'hidden', p: 0 }, { minWidth: "22rem" }]}
              >
              <Box sx={[{
                "& .MuiGrid-item": { borderRight: "1px solid #eeeff8", borderBottom: "1px solid #eeeff8", position: "relative" },
                "& .MuiGrid-item:nth-last-of-type(-n+1)": { borderBottomWidth: 0 },
                "& .MuiGrid-item:nth-of-type(2n)": { borderRightWidth: 1 },
                "& .MuiGrid-item:nth-last-of-type(-n+3)": { borderBottomWidth: 0 },
                "& .MuiGrid-item:nth-of-type(3n)": { borderRightWidth: 0 },
                "& .MuiGrid-item:nth-last-of-type(-n+4)": { borderBottomWidth: 0 },
                "& .MuiGrid-item:nth-of-type(4n)": { borderRightWidth: 0 },
                "& > .btn": { display: "block", border: 0, minWidth: "100%" },
              }, {
                "& .MuiGrid-item:nth-of-type(2n)": { borderRightWidth: 0 },
              }]}>
                <Grid container spacing={0}>
                  {map(visibleInputFields, (section) => {
                    if (!section.component) {
                      return (
                        <Grid
                          size={{ sm: section.xs || 6 }}
                          key={section.title}
                        >
                          <LaunchpadButton
                            title={section.title}
                            subtitle={section.subTitle}
                            icon={[section.icon1, section.icon2]}
                            to={section.href}
                            disabled={!Boolean(anchorEl3)}
                          />
                        </Grid>
                      )
                    } else {
                      return section.component
                    }
                  })}
                  {/* <Grid size={{sm: 6}}>
                    <Button
                      variant="text">
                      <FontAwesomeIcon
                        icon={['far', 'circle-question']}
                      />
                      <div>
                        Upload Properties
                      </div>
                      <div>
                        Multiple addresses
                      </div>
                    </Button>
                  </Grid>
                  <Grid size={{sm: 6}}>
                    <Button
                      variant="text">
                      <FontAwesomeIcon
                        icon={['far', 'compass']}
                      />
                      <div>
                        Create Portfolio
                      </div>
                      <div>
                        Keep it organized
                      </div>
                    </Button>
                  </Grid>
                  <Grid size={{sm: 6}}>
                    <Button
                      variant="text">
                      <FontAwesomeIcon
                        icon={['far', 'comment-dots']}
                      />
                      <div>Organization</div>
                      <div>
                        Starting new project?
                      </div>
                    </Button>
                  </Grid> */}
                </Grid>
              </Box>
            </Box>
          </Menu>
        </Box>
      </Box>
    </>
  )
}

export default HeaderDots
